// extracted by mini-css-extract-plugin
module.exports = {"spacer":"ToolBarSpacer_spacer__3spMK"};